/* @flow */

import * as types from './keywordActionTypes';
import {
  assertNumber,
  assertObject,
  assertLooseString,
} from '@e180/util/lib/assert';

import {
  keywordsEndpoint,
  featuredKeywordsEndpoint,
} from 'src/shared/app/base/settings/endpointSettings';
import { parseResponse } from 'src/shared/app/base/util/ajaxUtils';
import * as namespaces from 'src/shared/app/topic/new/action/appNewTopicActionNamespaces';

import type { Keyword } from 'src/shared/domain/keyword/type/keywordTypes';

/*
 |------------------------------------------------------------------------------
 | Fetch
 |------------------------------------------------------------------------------
 */

export function fetchKeywords(
  eventId: number,
  options?: Object,
  namespace?: string,
) {
  assertNumber(eventId, 'eventId');
  assertLooseString(namespace, 'namespace');

  let params = {};
  let isOffset = false;

  if (options) {
    assertObject(options, 'options');

    if ('offset' in options) {
      isOffset = true;
    }

    params = options;
  }

  return (dispatch: any, { get }: Object) => {
    dispatch(fetchKeywordsRequest(isOffset, namespace));

    return get(
      namespace === namespaces.NEW_TOPIC_RECOMMENDED_KEYWORDS
        ? featuredKeywordsEndpoint(eventId)
        : keywordsEndpoint(eventId),
      params,
    )
      .then(parseResponse)
      .then((json) => dispatch(fetchKeywordsSuccess(json, isOffset, namespace)))
      .catch((e) => {
        dispatch(fetchKeywordsFailure(e, isOffset, namespace));

        throw e;
      });
  };
}

export function fetchKeywordsRequest(
  isOffset?: boolean = false,
  namespace?: string,
) {
  return {
    type: types.FETCH_KEYWORDS_REQUEST,
    isOffset,
    namespace,
  };
}

export function fetchKeywordsSuccess(
  result: Array<Keyword>,
  isOffset?: boolean = false,
  namespace?: string,
) {
  return {
    type: types.FETCH_KEYWORDS_SUCCESS,
    result,
    isOffset,
    namespace,
  };
}

export function fetchKeywordsFailure(
  exception: Error,
  isOffset?: boolean = false,
  namespace?: string,
) {
  return {
    type: types.FETCH_KEYWORDS_FAILURE,
    exception,
    isOffset,
    namespace,
  };
}

/*
 |------------------------------------------------------------------------------
 | Reset keywords
 |------------------------------------------------------------------------------
 */

export function resetKeywords(namespace?: string) {
  return {
    type: types.RESET_KEYWORDS,
    namespace,
  };
}
